import React from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
import { useIntersectionObserver } from './useIntersectionObserver';
export function TestimonialSection() {
  const {
    elementRef,
    isVisible
  } = useIntersectionObserver();
  return <section className="bg-navy-dark py-16 md:py-24 relative overflow-hidden" data-id="element-135">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-4xl bg-gold-primary/5 rounded-full blur-3xl pointer-events-none" data-id="element-136"></div>

      <div ref={elementRef} className={`max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 fade-in-section ${isVisible ? 'is-visible' : ''}`} data-id="element-137">
        <div className="text-center mb-8" data-id="element-138">
          <h2 className="text-sm font-bold text-gold-primary uppercase tracking-widest" data-id="element-139">
            Resultados Reales
          </h2>
        </div>

        <div className="bg-navy-light p-8 md:p-12 rounded-2xl border border-gold-primary/20 shadow-2xl relative" data-id="element-140">
          <QuoteIcon className="absolute top-6 left-6 w-12 h-12 text-gold-primary/10" data-id="element-141" />

          <div className="flex justify-center gap-1 mb-6" data-id="element-142">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-6 h-6 text-gold-primary fill-gold-primary" data-id="element-143" />)}
          </div>

          <blockquote className="text-xl md:text-2xl lg:text-3xl text-white font-heading italic text-center leading-relaxed mb-8" data-id="element-144">
            "No lo podía creer. Pensé que mi hijo ya no contaba como dependiente
            porque trabajaba en la tienda de la esquina. Apliqué el Hack #2 y mi
            reembolso subió $1,400 adicionales este año. ¡Gracias!"
          </blockquote>

          <div className="text-center" data-id="element-145">
            <div className="font-bold text-gold-light text-lg" data-id="element-146">Carlos R.</div>
            <div className="text-gray-400" data-id="element-147">Texas</div>
          </div>
        </div>
      </div>
    </section>;
}